/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: dcc64d2b9d0632d606c9c2cb639ce99b329dbe9c601955ba339a8f303306b3a5
 */
import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'

import style from './MenuOptionTertiary.style'

type MenuOptionTertiaryOwnProps = {
  className?: string
  aiPowered?: boolean
  icon?: React.ReactNode
  subtext?: React.ReactNode
  title: string
  trailing?: React.ReactNode
  variant?: 'default' | 'severe'
}

export type MenuOptionTertiaryProps = MenuOptionTertiaryOwnProps & Omit<ComponentProps<'button'>, keyof MenuOptionTertiaryOwnProps | 'children'>

function MenuOptionTertiary(props: MenuOptionTertiaryProps): ReactElement {
  const {
    className = '',
    aiPowered = false,
    icon,
    subtext,
    title,
    trailing,
    variant = 'default',
    ...rest
  } = props

  return (
    <button
      className={cn('MenuOptionTertiary', className, variant, { aiPowered })}
      css={style}
      {...rest}
      type='button'
      role={rest.role ?? 'menuitem'}
    >
      <span className='contentRow'>
        {icon ? <span aria-hidden={true} className='iconWrapper'>{icon}</span> : null}
        {aiPowered ? <span aria-hidden={true} className='aiPill' /> : null}
        <span className='textStack'>
          <span className='title'>{title}</span>
          {subtext ? <span className='subtext'>{subtext}</span> : null}
        </span>
      </span>
      {trailing ? <span className='trailingWrapper'>{trailing}</span> : null}
    </button>
  )
}

export default MenuOptionTertiary
